import { CanActivateFn } from "@angular/router";
import { Observable } from "rxjs";
import { ActivationService } from "../../services/activation.service";
import { inject } from "@angular/core";

export const activationGuard: CanActivateFn = (_route, _state): Observable<boolean> => {
  const activationService = inject(ActivationService);
  return activationService.canActivate();
}